import { useQueryClient as l, useMutation as y, useQuery as E } from "@tanstack/react-query";
import t from "./profile.api.js";
import { teachurKeys as d } from "../../constants/teachurKeys.js";
const F = () => E({
  queryKey: d.billing.info(),
  queryFn: async () => (await t.getBillingInfo()).data
}), S = (e) => {
  const r = l();
  return y({
    mutationFn: async (a) => (await t.updateCard(a)).data,
    onSuccess: (a, u, n) => {
      var c;
      r.invalidateQueries({ queryKey: BILLING_INFO_KEY }), (c = e == null ? void 0 : e.onSuccess) == null || c.call(e, a, u, n);
    },
    onError: e == null ? void 0 : e.onError,
    ...e
  });
}, C = (e) => {
  const r = l();
  return y({
    mutationFn: async (a) => (await t.deleteCard(a)).data,
    onSuccess: (a, u, n) => {
      var c;
      r.invalidateQueries({ queryKey: BILLING_INFO_KEY }), (c = e == null ? void 0 : e.onSuccess) == null || c.call(e, a, u, n);
    },
    onError: e == null ? void 0 : e.onError,
    ...e
  });
}, K = (e) => {
  const r = l();
  return y({
    mutationFn: async (a) => (await t.updateSubscriptionDay(a)).data,
    onSuccess: (a, u, n) => {
      var c;
      r.invalidateQueries({ queryKey: BILLING_INFO_KEY }), (c = e == null ? void 0 : e.onSuccess) == null || c.call(e, a, u, n);
    },
    onError: e == null ? void 0 : e.onError,
    ...e
  });
}, f = (e, r) => {
  const a = l();
  return y({
    mutationFn: async (u) => (await t.updatePersonalInfo(e, u)).data,
    onSuccess: (u, n, c) => {
      var s;
      a.invalidateQueries({ queryKey: d.users.currentUser() }), (s = r == null ? void 0 : r.onSuccess) == null || s.call(r, u, n, c);
    },
    onError: r == null ? void 0 : r.onError
  });
}, Q = (e) => y({
  mutationFn: async (r) => (await t.uploadFile(r)).data,
  onError: e == null ? void 0 : e.onError,
  ...e
}), v = (e) => {
  const r = l();
  return y({
    mutationFn: async (a) => (await t.uploadAvatar(a)).data,
    onSuccess: (a, u, n) => {
      var c;
      r.invalidateQueries({ queryKey: d.users.currentUser() }), (c = e == null ? void 0 : e.onSuccess) == null || c.call(e, a, u, n);
    },
    onError: e == null ? void 0 : e.onError,
    ...e
  });
};
export {
  C as useDeleteCardMutation,
  F as useGetBillingInfoQuery,
  S as useUpdateCardMutation,
  f as useUpdatePersonalInfoMutation,
  K as useUpdateSubscriptionDayMutation,
  v as useUploadAvatarMutation,
  Q as useUploadFileMutation
};
